if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      /**
       * @param {HTMLElement} opener
       */
      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        if (!this.openedBy) {return;}
        const mediaId = this.openedBy.getAttribute('data-media-id');
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${mediaId}"])`
        ).forEach((/** @type {Element} */ element) => {
          element.classList.remove('active');
        });
        const activeMedia = /** @type {HTMLElement & { loadContent?: () => void }} */ (
          this.querySelector(`[data-media-id="${mediaId}"]`)
        );
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = /** @type {HTMLElement} */ (this.querySelector('[role="document"]'));
        container.scrollLeft = (/** @type {HTMLImageElement} */ (activeMedia).width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName === 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          {activeMedia.loadContent?.();}
      }
    }
  );
}
